import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as ReasonStandardHttp from '../../../../services/api/https/system/missing-reason-standard.http'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_REASONS: 'Adquirindo ocorrências',
}

const INITIAL_STATE = {
  ocorrencias: [],
  modal: {
    show: false,
    data: null,
  },
  loadingMessage: LOAD_MESSAGE.GET_REASONS,
  errorMessage: null,
}

const INITIAL_OCCURRENCE = {
  id: null,
  sigla: '',
  descricao: '',
  type: 'Falta',
  visible_picking: false,
  visible_delivery: false,
  devolucao_fisica: true,
  actived: true,
}

export default function useOcorrenciaPadraoEmpresa() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      getMissingReasonStandard() {
        ReasonStandardHttp.getMissingReasonStandard()
          .then(ocorrencias =>
            setState(prevState => ({
              ...prevState,
              ocorrencias: ocorrencias,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      toggleModalProduto(show, data) {
        setState(prevState => ({ ...prevState, modal: { show, data } }))
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      onBtnNovo(selectedEmpresaID) {
        if (selectedEmpresaID !== '')
          setState(prevState => ({
            ...prevState,
            modal: { show: true, data: { ...INITIAL_OCCURRENCE, company_id: selectedEmpresaID } },
          }))
        else setState(prevState => ({ ...prevState, errorMessage: 'Selecione a empresa desejada' }))
      },

      onModalClose() {
        setState(prevState => ({
          ...prevState,
          modal: { show: false, data: { ...INITIAL_OCCURRENCE } },
        }))
      },

      onModalSave(ocorrencia) {
        setState(prevState => {
          const index = prevState.ocorrencias.findIndex(o => o.id === ocorrencia.id)
          if (index !== -1) prevState.ocorrencias[index] = ocorrencia
          else prevState.ocorrencias.push(ocorrencia)
          return { ...prevState, modal: { show: false, data: null } }
        })
      },

      onRowClicked(ocorrencia) {
        setState(prevState => ({ ...prevState, modal: { show: true, data: ocorrencia } }))
      },
    }
  }, [])

  return { state, localDispatch }
}
